import React from 'react'
import { css, useTheme } from '@emotion/react'
import PinIcon from 'components/PinIcon'
import { Flex } from 'shared/ui'
import { Checkbox } from 'util/ui'
import { translate } from './util'
import Count from './Count'
import SortMenu from './SortMenu'
import BulkActionBar from './BulkActionBar'

export default function WideSwitcher(props) {
  const { isSelectionMode, BulkActionBarComponent = BulkActionBar } = props
  const theme = useTheme()

  if (isSelectionMode) {
    return <BulkActionBarComponent theme={theme} {...props} />
  }

  return <WideBar theme={theme} {...props} />
}

const pinIconStyle = css`
  &::before {
    vertical-align: middle;
  }
`

function WideBar(props) {
  const {
    canSeePinnedSearches,
    isFreeFormSearch,
    isSearchPinnable,
    onPinUnpinClick,
    onSelectAllClick,
    pinnedSearch,
    searchIsFolderSearch,
    title,
    CountComponent = Count,
    SortMenuComponent = SortMenu,
    theme,
  } = props

  const getTitleLabel = () => {
    if (isFreeFormSearch) return 'Search results'
    if (searchIsFolderSearch) return title
    return translate(title)
  }

  const titleComponent = (
    <Flex
      className="grui overflow-hidden items-baseline"
      css={css`
        flex-grow: 1;
      `}
    >
      <div
        css={css`
          font-size: ${theme.fontSize.x2large};
          line-height: ${theme.lineHeight.leadingNormal};
          color: ${theme.color.monochrome.black};
          font-weight: ${theme.fontWeight.medium};
        `}
      >
        {getTitleLabel()}
      </div>
      <CountComponent />
    </Flex>
  )

  return (
    <Flex
      css={css`
        min-height: 42px;
        padding: ${`${theme.spacing['5']} ${theme.spacing['6']}
          ${theme.spacing['5']} ${theme.spacing['10']}`};
        border-bottom: 1px solid ${theme.color.monochrome.medium};
      `}
      className="grui items-center conversation-list-header-title-bar"
    >
      <Checkbox
        checked={false}
        css={css`
          margin-right: 16px;
        `}
        onClick={onSelectAllClick}
      />
      {titleComponent}
      <Flex>
        {canSeePinnedSearches &&
          isSearchPinnable && (
            <PinIcon
              size="small"
              isPinned={!!pinnedSearch}
              onPinClick={onPinUnpinClick}
              iconCss={pinIconStyle}
            />
          )}
        <SortMenuComponent className="grui ml-5" />
      </Flex>
    </Flex>
  )
}
